<template>
    <div>
        <div class="head">
            <img src="../../static/img/01.png" alt="松科智能" class="head_icon" @click="goIndex">
            <div class="navbar">
                <div class="navbar_horizontal" v-if="show_horizontal">
                    <div :class="{ navbar_horizontal_item : activeIndex == index, navbar_horizontal_item1 : activeIndex != index }" v-for="(item, index) in navbar" :key="index" @click="handleSelect(index)">
                        {{item.title}}
                    </div>
                </div>
                <div class="navbar_vertical" v-else>
                    <div @click="drawer = true">
                        <div class="heng"></div>
                        <div class="heng"></div>
                        <div class="heng"></div>
                    </div>
                    <el-drawer
                        :visible.sync="drawer"
                        :show-close="false"
                        direction="ttb">
                        <div class="search1">
                            <el-input
                                placeholder="输入关键词搜索" @change="Search()"
                                v-model="keyword" style="border:none;">
                            </el-input>
                            <img src="../../static/img/02.png" class="search_button" @click="Search()">
                        </div>
                        <div class="draw_navbar">
                            <div class="draw_navbar_item" :class="{ draw_navbar_item1 : activeIndex == index, draw_navbar_item : activeIndex != index }" v-for="(item, index) in navbar" :key="index" @click="handleSelect(index)">
                                {{item.title}}
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
            <div class="search" v-if="show_horizontal">
                 <el-input
                    placeholder="输入关键词搜索" @change="Search()"
                    v-model="keyword" style="border:none;">
                </el-input>
                <img src="../../static/img/02.png" class="search_button" @click="Search()">
            </div>
        </div>
        <div class="detail">
            <div class="detail1">
                <div class="detail11">
                    <div class="detail1_item1">
                        <div class="goindex" @click="goList">{{title}}</div>
                        <img src="../../static/img/05.png">
                        <div class="godetail">正文</div>
                    </div>
                    <div class="detail_name">{{detail.title}}</div>
                </div>
                <div class="detail_write">
                    <div>发布者：{{detail.author}}</div>
                    <div style="margin: 0 40px; line-height: 20px;">{{detail.created_at | Time()}}</div>
                    <div>阅读：{{detail.read}}</div>
                </div>
            </div>
            <div class="detail2">
                <div class="detail2_html" v-html="detail.context"></div>
                <!-- http://communityadmin.gdsoke.com/storage/files/14.PNG -->
                <div v-if="detail.files !== undefined && detail.files.length > 0">
                    <div class="files_title">附件:</div>
                    <div v-for="(item, index) in detail.files" :key="index" class="file_item" @click="download(item.path)">
                        {{index+1}}.   {{item.name}}
                    </div>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>

<script>
export default {
    data () {
        return {
            drawer: false,
            show_horizontal: true, // 切换导航栏显示方式
            activeIndex: 0,
            navbar: [], // 导航栏列表
            keyword: '', // 搜索关键词
            id: '', // 正文的id
            md_id: '', // 模块的id
            title: '', // 模块类型名字
            detail: '' // 详情
        }
    },
    created () {
        // 获取导航栏
        this.getNavBar()
        this.id = this.$route.params.id
        this.activeIndex = this.$route.query.m_index
        this.md_id = this.$route.query.md_id
        this.title = this.$route.query.title
        var screenWidth = window.screenWidth || document.body.clientWidth
        if (screenWidth < 768) {
            this.show_horizontal = false
        } else {
            this.show_horizontal = true
        }
        // 获取正文详情
        this.getGetail(this.$route.params.id)
    },
    mounted () {
        const that = this
        window.addEventListener('resize', () => {
            var screenWidth = window.screenWidth || document.body.clientWidth
            if (screenWidth < 768) {
                that.show_horizontal = false
            } else {
                that.show_horizontal = true
            }
        }, false)
    },
    filters: {
        Time (value) {
            if (value) {
                var a = value.split(' ')[0]
                return a
            }
        }
    },
    methods: {
        // 跳转到首页
        goIndex () {
            const url1 = this.$router.resolve({name: 'Index'})
            window.open(url1.href, '_blank')
        },
        // 获取导航栏
        getNavBar () {
            this.$axios.get('/menus')
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            this.navbar = res.data.data
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        // 选择导航栏
        handleSelect (index) {
            const url1 = this.$router.resolve({name: 'Index', query: { index: index }})
            window.open(url1.href, '_blank')
            this.drawer = false
        },
        // 获取正文详情
        getGetail (id) {
            this.$axios.get(`/article/${id}/details`)
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.status) {
                            this.detail = res.data.data
                        } else {
                            this.$message({
                                showClose: true,
                                message: '获取数据失败',
                                type: 'error',
                                duration: '1500',
                                offset: '80'
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取数据失败',
                            type: 'error',
                            duration: '1500',
                            offset: '80'
                        })
                    }
                })
                .catch(error => { // 请求失败处理
                    console.log(error)
                    this.$message({
                        showClose: true,
                        message: '获取数据失败',
                        type: 'error',
                        duration: '1500',
                        offset: '80'
                    })
                })
        },
        // 传递搜索关键词给组件Index
        Search () {
            if (this.keyword) {
                const url1 = this.$router.resolve({name: 'List', query: { m_id: this.navbar[this.activeIndex].id, m_index: this.activeIndex, keyword: this.keyword }})
                window.open(url1.href, '_blank')
                this.drawer = false
            } else {
                this.$message({
                    showClose: true,
                    message: '请输入关键字',
                    type: 'warning',
                    duration: '1500',
                    offset: '80'
                })
            }
        },
        // 跳转到列表页
        goList () {
            const url1 = this.$router.resolve({name: 'List', query: { m_id: this.navbar[this.activeIndex].id, m_index: this.activeIndex, md_id: this.md_id }})
            window.open(url1.href, '_blank')
        },
        // 下载附件
        download (path) {
            var url = this.$root.downloadURL + path
            window.open(url)
        }
    }
}
</script>

<style scoped>
    @import "./detail.css";
</style>



// WEBPACK FOOTER //
// src/view/detail.vue